import {
	AbstractControl,
	NG_VALIDATORS,
	Validator,
	ValidationErrors
} from '@angular/forms';
import {
	Directive,
	Input
} from '@angular/core';
import { get } from 'lodash';

@Directive({
	selector: '[commonMaxlength]',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: CommonMaxlengthValidatorDirective,
		multi: true,
	}],
})
export class CommonMaxlengthValidatorDirective implements Validator {
	@Input() commonMaxlength: number;
	@Input() pathValue: string;

	validate (control: AbstractControl): ValidationErrors | null {
		if (this.pathValue) {
			return get(control, `value.${this.pathValue}.length`, null) <= this.commonMaxlength ? null : {
				maxLength: true,
			};
		}
		return get(control, 'value.length', null) <= this.commonMaxlength ? null : {
			maxLength: true,
		};
	}
}
